const none = "none";
const small = "var(--sscs-box-shadow-small)";
const medium = "var(--sscs-box-shadow-medium)";
const large = "var(--sscs-box-shadow-large)";
export default function themeShadows() {
    return [
        none,
        ...Array(4).fill(small), // 1–4  low elevation
        ...Array(8).fill(medium), // 5–12 medium elevation
        ...Array(12).fill(large), // 13–24 high elevation
    ];
}
//# sourceMappingURL=shadows.js.map